/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Warehouse_AuditInputs */

const en_audit_warehouse_audit = /** @type {(inputs: Audit_Warehouse_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse Audit`)
};

const es_audit_warehouse_audit = /** @type {(inputs: Audit_Warehouse_AuditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auditoria de Almacen`)
};

/**
* | output |
* | --- |
* | "Warehouse Audit" |
*
* @param {Audit_Warehouse_AuditInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_warehouse_audit = /** @type {((inputs?: Audit_Warehouse_AuditInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Warehouse_AuditInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_warehouse_audit(inputs)
	return es_audit_warehouse_audit(inputs)
});